import React from 'react'
import clsx from 'clsx'
import {
  Dialog,
  DialogContent,
  Typography,
  makeStyles,
  createStyles,
  useMediaQuery,
  useTheme,
} from '@material-ui/core'
import CancelIcon from '@material-ui/icons/Cancel'
import HelpOutlineOutlinedIcon from '@material-ui/icons/HelpOutlineOutlined'
import Slide from '@material-ui/core/Slide'
import { TransitionProps } from '@material-ui/core/transitions'
import CMSText from '../Global/CMSText'

const useStyles = makeStyles((theme) =>
  createStyles({
    dialog: {
      gap: theme.spacing(2),
      '& .MuiDialog-paperWidthSm': {
        [theme.breakpoints.up('lg')]: {
          maxWidth: theme.breakpoints.width('md'),
        },
      },
      '& .MuiPaper-root': {
        backgroundColor: 'inherit',
      },
    },
    dialogHeader: {
      display: 'inline-flex',
      justifyContent: 'flex-end',
      alignItems: 'center',
      marginBottom: theme.spacing(2),
      color: theme.palette.common.white,
    },
    cross: {
      cursor: 'pointer',
      height: 37,
      width: 37,
      padding: theme.spacing(0.5),
      color: theme.palette.common.white,
    },
    dialogContent: {
      backgroundColor: theme.palette.common.white,
      borderRadius: theme.shape.borderRadius,
      padding: theme.spacing(3, 5, 2),
      [theme.breakpoints.down('xs')]: {
        padding: theme.spacing(1),
      },
    },
    dialogTitle: {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      margin: theme.spacing(0, 0, 2),
      color: theme.palette.primary.main,
      '& .paragraph-class': {
        margin: 0,
      },
    },
    referenceImg: {
      display: 'block',
      maxWidth: '100%',
      height: 'auto',
      margin: 'auto',
      marginBottom: theme.spacing(2),
    },
    modalText: {},
  })
)

const Transition = React.forwardRef(function Transition(
  props: TransitionProps & { children?: React.ReactElement<any, any> },
  ref: React.Ref<unknown>
) {
  return <Slide direction="up" ref={ref} {...props} />
})

type Tprops = {
  open: any
  handleClose: any
  t: any
  takeBackData: any
}
const ReferenceModal = ({ open, handleClose, t, takeBackData }: Tprops) => {
  const modalClasses = useStyles()
  const theme = useTheme()
  const fullScreen = useMediaQuery(theme.breakpoints.down('xs'))

  return (
    <Dialog
      fullScreen={fullScreen}
      open={open}
      onClose={handleClose}
      TransitionComponent={Transition}
      className={clsx('takeBack-dialog', modalClasses.dialog)}
    >
      <DialogContent
        className={clsx('takeBack-dialog__content', modalClasses.dialogContent)}
      >
        <div
          className={clsx('takeBack-dialog__header', modalClasses.dialogHeader)}
        >
          <Typography
            variant="h4"
            className="takeBack-dialog__header__close-text"
          >
            {t('texts:takeBack:close_modal')}
          </Typography>
          <CancelIcon
            onClick={handleClose}
            className={clsx(
              'takeBack-dialog__header__close-icon',
              modalClasses.cross
            )}
          />
        </div>
        <Typography
          variant="h3"
          component="h3"
          className={clsx('takeBack-dialog__title', modalClasses.dialogTitle)}
        >
          <HelpOutlineOutlinedIcon />
          <div>
            <CMSText
              data={takeBackData?.reference_number_explication_title}
              defaultText={t('texts:takeBack:reference_number_link')}
            />
          </div>
        </Typography>
        <Typography
          variant="body1"
          component="div"
          className={clsx('takeBack-dialog__wysiwyg', modalClasses.modalText)}
        >
          <CMSText
            data={takeBackData?.reference_number_explication_text}
            defaultText={t()}
          />
        </Typography>
      </DialogContent>
    </Dialog>
  )
}

export default ReferenceModal
